import FetchData from '../../ServerCall/FetchData';
import fetchUserThemes from '../../../api/fetchUserThemes';

export interface ColorSchemesProps {
  name: string;
  background: string;
  tableHeaderBackground: string;
  colors: string[];
  dark?: boolean;
  id?: string;
}

export const ColorSchemes: ColorSchemesProps[] = [
  {
    id: 'peacock',
    name: 'peacock',
    background: '#ffffff',
    tableHeaderBackground: 'rgb(247, 247, 247)',
    colors: [
      '#2bb9bb',
      '#af99db',
      '#5ab1ef',
      '#ffb980',
      '#d87a80',
      '#8d98b3',
      '#e5cf0d',
      '#97b552',
      '#95706d',
      '#dc69aa',
    ],
  },
  {
    id: 'essos',
    name: 'essos',
    background: 'rgba(255,249,211,1)',
    tableHeaderBackground: 'rgb(255, 245, 170)',
    colors: ['#893448', '#d95850', '#eb8146', '#ffb248', '#f2d643', '#ebdba4'],
  },
  {
    id: 'infographic',
    name: 'infographic',
    background: 'rgba(255,255,255,1)',
    tableHeaderBackground: 'rgb(247, 247, 247)',
    colors: [
      '#c1232b',
      '#27727b',
      '#fcce10',
      '#e87c25',
      '#b5c334',
      '#fe8463',
      '#9bca63',
      '#fad860',
      '#f3a43b',
      '#60c0dd',
      '#d7504b',
      '#c6e579',
      '#f4e001',
      '#f0805a',
      '#26c0c0',
    ],
  },
  {
    id: 'macarons',
    name: 'macarons',
    background: 'rgba(255,255,255,1)',
    tableHeaderBackground: 'rgb(247, 247, 247)',
    colors: [
      '#2ec7c9',
      '#b6a2de',
      '#5ab1ef',
      '#ffb980',
      '#d87a80',
      '#8d98b3',
      '#e5cf0d',
      '#97b552',
      '#95706d',
      '#dc69aa',
      '#07a2a4',
      '#9a7fd1',
      '#588dd5',
      '#f5994e',
      '#c05050',
      '#59678c',
      '#c9ab00',
      '#7eb00a',
      '#6f5553',
      '#c14089',
    ],
  },
  {
    id: 'roma',
    name: 'roma',
    background: 'rgba(255,255,255,1)',
    tableHeaderBackground: 'rgb(247, 247, 247)',
    colors: [
      '#e01f54',
      '#001852',
      '#f5e8c8',
      '#b8d2c7',
      '#c6b38e',
      '#a4d8c2',
      '#f3d999',
      '#d3758f',
      '#dcc392',
      '#2e4783',
      '#82b6e9',
      '#ff6347',
      '#a092f1',
      '#0a915d',
      '#eaf889',
      '#6699FF',
      '#ff6666',
      '#3cb371',
      '#d5b158',
      '#38b6b6',
    ],
  },
  {
    id: 'shine',
    name: 'shine',
    background: 'rgba(255,255,255,1)',
    tableHeaderBackground: 'rgb(247, 247, 247)',
    colors: [
      '#c12e34',
      '#e6b600',
      '#0098d9',
      '#2b821d',
      '#005eaa',
      '#339ca8',
      '#cda819',
      '#32a487',
    ],
  },
  {
    id: 'vintage',
    name: 'vintage',
    background: 'rgba(254,248,239,1)',
    tableHeaderBackground: 'rgb(240, 230, 220)',
    colors: [
      '#d87c7c',
      '#919e8b',
      '#d7ab82',
      '#6e7074',
      '#61a0a8',
      '#efa18d',
      '#787464',
      '#cc7e63',
      '#724e58',
      '#4b565b',
    ],
  },
  {
    id: 'walden',
    name: 'walden',
    background: 'rgba(255,255,255,1)',
    tableHeaderBackground: 'rgb(247, 247, 247)',
    colors: ['#3fb1e3', '#6be6c1', '#626c91', '#a0a7e6', '#c4ebad', '#96dee8'],
  },
  {
    id: 'westeros',
    name: 'westeros',
    background: 'rgba(255,255,255,1)',
    tableHeaderBackground: 'rgb(247, 247, 247)',
    colors: ['#516b91', '#59c4e6', '#edafda', '#93b7e3', '#a5e7f0', '#cbb0e3'],
  },
  {
    id: 'wonderland',
    name: 'wonderland',
    background: 'rgba(255,255,255,1)',
    tableHeaderBackground: 'rgb(247, 247, 247)',
    colors: ['#4ea397', '#22c3aa', '#7bd9a5', '#d0648a', '#f58db2', '#f2b3c9'],
  },
  {
    id: 'chalk',
    name: 'chalk',
    background: 'rgba(41,52,65,1)',
    tableHeaderBackground: 'rgb(80, 95, 115)',
    dark: true,
    colors: [
      '#fc97af',
      '#87f7cf',
      '#f7f494',
      '#72ccff',
      '#f7c5a0',
      '#d4a4eb',
      '#d2f5a6',
      '#76f2f2',
    ],
  },
  {
    id: 'dark',
    name: 'dark',
    background: 'rgba(51,51,51,1)',
    tableHeaderBackground: 'rgb(100, 100, 100)',
    dark: true,
    colors: [
      '#dd6b66',
      '#759aa0',
      '#e69d87',
      '#8dc1a9',
      '#ea7e53',
      '#eedd78',
      '#73a373',
      '#73b9bc',
      '#7289ab',
      '#91ca8c',
      '#f49f42',
    ],
  },
  {
    id: 'halloween',
    name: 'halloween',
    background: 'rgba(64,64,64,1)',
    tableHeaderBackground: 'rgb(125, 125, 125)',
    dark: true,
    colors: ['#ff715e', '#ffaf51', '#ffee51', '#8c6ac4', '#715c87'],
  },
  {
    id: 'purplePassion',
    name: 'purplePassion',
    background: 'rgba(91,92,110,1)',
    tableHeaderBackground: 'rgb(139, 130, 150)',
    dark: true,
    colors: ['#9b8bba', '#e098c7', '#8fd3e8', '#71669e', '#cc70af', '#7cb4cc'],
  },
];
export const colors = [
  '#af99db',
  '#5ab1ef',
  '#ffb980',
  '#d87a80',
  '#8d98b3',
  '#e5cf0d',
  '#97b552',
  '#95706d',
  '#dc69aa',
];

export interface CombinedTheme extends ColorSchemesProps {
  isUser?: boolean;
  themeId?: string;
}

let cachedColorSchemes: CombinedTheme[] | null = null;

export const getAllColorSchemes = async (): Promise<CombinedTheme[]> => {
  if (cachedColorSchemes) return cachedColorSchemes;

  try {
    const { themes: userThemesRaw } = await fetchUserThemes();

    const userThemes: CombinedTheme[] = userThemesRaw.map((theme) => ({
      id: theme.themeId,
      name: theme.themeName,
      background: theme.background,
      tableHeaderBackground: theme.tableHeaderBackground,
      colors: theme.colors,
      isUser: true
    }));

    cachedColorSchemes = [...ColorSchemes, ...userThemes];
    return cachedColorSchemes;
  } catch (err) {
    console.error('Failed to fetch user themes', err);
    cachedColorSchemes = [...ColorSchemes];
    return cachedColorSchemes;
  }
};

